/** Each tab is its own route, `/maintenance/<tab>`, so the URL, the breadcrumbs and the sidebar's highlight all agree. */
export const MAINTENANCE_TABS = [
  'service-items',
  'work-orders',
  'garages',
  'workshop-bookings',
  'suppliers',
  'tyres',
  'parts',
  'part-types',
  'catalogues',
] as const;
export type MaintenanceTab = (typeof MAINTENANCE_TABS)[number];

export const MAINTENANCE_TAB_LABELS: Record<MaintenanceTab, string> = {
  'service-items': 'Service items',
  'work-orders': 'Work orders',
  garages: 'Garages',
  'workshop-bookings': 'Workshop bookings',
  suppliers: 'Suppliers',
  tyres: 'Tyres',
  parts: 'Parts fitted',
  'part-types': 'Part types',
  catalogues: 'Service types & categories',
};

export function maintenanceTabPath(tab: MaintenanceTab): string {
  return `/maintenance/${tab}`;
}
